import { AclKeys, AclValues } from "common/records/User";
import { currentUserPermissions } from "common/selectors/user.selectors";
import React from "react";
import { useSelector } from "react-redux";

interface CanProps {
  children: React.ReactNode;
  resource: AclKeys;
  permission: AclValues;
  inverse?: boolean;
}

const Can: React.FC<CanProps> = ({ children, resource, permission, inverse }) => {
  const permissions = useSelector(currentUserPermissions);

  let decision = permissions?.get(resource)?.includes(permission);
  if (inverse) {
    decision = !decision;
  }

  if (decision) return <>{children}</>;

  return null;
};

export default Can;
